/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./list.item.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./list.item.component";
var styles_ListItemComponent = [i0.styles];
var RenderType_ListItemComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_ListItemComponent, data: {} });
export { RenderType_ListItemComponent as RenderType_ListItemComponent };
export function View_ListItemComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_ListItemComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ig-list-item", [], [[2, "gray", null], [2, "contain-link", null], [2, "ic-list-item", null]], null, null, View_ListItemComponent_0, RenderType_ListItemComponent)), i1.ɵdid(1, 49152, null, 0, i2.ListItemComponent, [], null, null)], null, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).isGray; var currVal_1 = i1.ɵnov(_v, 1).link; var currVal_2 = true; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2); }); }
var ListItemComponentNgFactory = i1.ɵccf("ig-list-item", i2.ListItemComponent, View_ListItemComponent_Host_0, { link: "link", isGray: "isGray" }, {}, ["*"]);
export { ListItemComponentNgFactory as ListItemComponentNgFactory };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/list/item/list.item.component.ngfactory.js.pre-build-optimizer.js